import { NgModule, Optional, SkipSelf } from '@angular/core';
import { IrdDatePipe, IsExternalUrlPipe, NullishPipe } from './pipes';
import { IMAGE_ORIGIN } from './providers/image-origin';
import { WINDOW, windowFactory } from './providers/window';
import { DragDataService } from './services/drag-data';

const PIPES = [IsExternalUrlPipe, NullishPipe, IrdDatePipe];

@NgModule({
  imports: [...PIPES],
  exports: [...PIPES],
  providers: [
    ...PIPES,
    DragDataService,
    {
      provide: WINDOW,
      useFactory: windowFactory,
    },
    {
      provide: IMAGE_ORIGIN,
      useFactory: (parentOrigin: string | null) => parentOrigin || null,
      deps: [[new Optional(), new SkipSelf(), IMAGE_ORIGIN]],
    },
  ],
})
export class CoreModule {}
